import ProgressBar from "../../components/dashboard/ProgressBar";
import { useEffect, useState } from "react";
import axios from "axios";

const baseUrl =
  process.env.REACT_APP_PUBLIC_API_URL
  
const Location = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    axios
      .get(`${baseUrl}/regional-distribution`)
      .then((response) => {
        const resData = response.data;
        if (resData.success && Array.isArray(resData.distribution)) {
          setData(resData.distribution);
        }
      })
      .catch((error) => console.error("Error fetching regional distribution:", error));
  }, []);

  return (
    <div className="bg-white rounded-2xl p-6 shadow-sm">
      <h2 className="text-lg font-semibold mb-6">Regional Distribution</h2>

      {data.length > 0 ? (
        <div className="space-y-4">
          {data.map((item) => (
            <div key={item.region}>
              <div className="flex justify-between text-sm mb-1">
                <span>{item.region}</span>
                <span className="text-green-700 font-semibold">
                  {item.count.toLocaleString()} ({item.percent}%)
                </span>
              </div>
              <ProgressBar value={item.percent} />
            </div>
          ))}
        </div>
      ) : (
        <p className="text-sm text-gray-500">No regional data yet.</p>
      )}
    </div>
  );
};

export default Location;
